import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import api from './api/api'
import { message } from "./utils/resMassage";

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.prototype.$message = message;

Vue.use(ElementUI)
router.beforeEach((to, from, next) => {
    if (to.path == '/login') {
        next()
    } else {
        const token = localStorage.getItem('token')
        if (token != '') {
            next()
        } else {
            next('/login')
        }
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')